// noinspection JSNonASCIINames,NonAsciiCharacters

import { EnvironmentProviders, makeEnvironmentProviders, Provider } from '@angular/core';
import { allEnabledFeatureFlagsProvider } from './feature-flags/fake-feature-flags.service';

interface CoreModuleOptions {
  /**
   * Configure a real feature flag service or no?
   *
   * Defaults to `true`
   */
  useFeatureFlags?: boolean;
}

/**
 * Identifies a particular kind of `SharecCoreFeature`.
 *
 * @publicApi
 */
export enum SharedCoreFeatureKind {
  InMemoryApi
}

/**
 * A feature for use when configuring `provideSharedCore`.
 *
 * @publicApi
 */
export interface SharedCoreFeature<KindT extends SharedCoreFeatureKind> {
  ɵkind: KindT;
  ɵproviders: Array<Provider | EnvironmentProviders>;
}

export function makeSharedCoreFeature<KindT extends SharedCoreFeatureKind>(
  kind: KindT,
  providers: Array<Provider | EnvironmentProviders>
): SharedCoreFeature<KindT> {
  return {
    ɵkind: kind,
    ɵproviders: providers
  };
}

export function provideSharedCore(
  config: CoreModuleOptions = {},
  ...features: SharedCoreFeature<SharedCoreFeatureKind>[]
) {
  const { useFeatureFlags } = config;
  return makeEnvironmentProviders([
    useFeatureFlags === false ? allEnabledFeatureFlagsProvider : [],
    ...features.map(feature => feature.ɵproviders)
  ]);
}
